<template>
  <div>
    <div class="position-relative">
      <div class="form-control cursor-pointer" @click="showDropDown = !showDropDown">
        <div class="d-flex">

          <div class="flex-fill">
            <div v-if="value && selected && (selected === value || selected.user_id.toString() === value.toString())">
              <div class="font-weight-bolder">{{ selected.first_name }} {{ selected.last_name }}</div>
            </div>
            <div v-if="!value" class="text-muted">
              {{ placeholder }}
            </div>
          </div>

          <div class="text-primary" v-if="working.length > 0">
            <span class="fa fa-spin fa-sync"></span>
          </div>

        </div>
      </div>

      <div class="dropdown-container" v-if="showDropDown">
        <div class="input-group sticky-top">
          <input type="text" class="form-control"
                 ref="searchTextInput"
                 @keydown="onKeyDownSearch"
                 :placeholder="searchPlaceholder" v-model="search"/>
          <button type="button" class="btn btn-primary" @click="retrieveUsers()">
            جستجو
          </button>
        </div>

        <div v-if="users && users.data">
          <div class="dp-item d-flex align-items-center" v-for="x in users.data" :key="x.city_id" @click="onSelect(x)">

            <img v-if="avatar" :src="x.avatar | serverUrl" style="width: 50px; vertical-align: middle"
                 class="rounded-circle mr-2 bg-secondary">

            <div class="font-weight-bolder">{{ x.first_name }} {{ x.last_name }}</div>
            <div class="small">
              {{ x.username }}
            </div>
          </div>
        </div>

        <div class="mt-2">
          <pagination :data="users" @change="retrieveUsers"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {xhr} from "@/tools/functions";
import Pagination from "./Pagination";

export default {
  name: "UserSelector",
  components: {Pagination},
  props: {
    value: {default: undefined},
    medicineCenterId: {default: undefined},
    placeholder: {default: 'انتخاب کاربر'},
    searchPlaceholder: {default: 'برای جستجو نام، نام خانوادگی و یا نام کابری را وارد کنید'},
    fullInfo: {default: false},
    role: {default: undefined},
    avatar: {default: undefined}
  },
  data: () => ({
    working: [],
    users: [],
    search: '',
    showDropDown: false,
    selected: null
  }),
  methods: {
    onKeyDownSearch(e) {
      if (e.key.toLowerCase() === 'enter') {
        e.preventDefault();
        this.retrieveUsers();
      }
    },
    retrieveUsers(page = 1) {
      this.working.push(Date.now());
      xhr('api/admin/users', 'get', {
        medicine_center_id: this.medicineCenterId,
        search: this.search,
        role: this.role,
        avatar: this.avatar ? 1 : undefined,
        page
      })
          .then(r => this.users = r.data)
          .finally(() => this.working.pop())
    },
    retrieveUserInfo() {
      this.working.push(Date.now());
      xhr(`api/admin/users/${this.value}`, 'get', {brief: 1})
          .then(r => this.selected = r.data)
          .finally(() => this.working.pop())
    },
    onSelect(user) {
      this.selected = user;
      this.$emit('input', this.fullInfo ? user : user.user_id, user);
      this.showDropDown = false;
    },
    globalClickListener(e) {
      let p = e.target;
      while (p && p !== window.document) {
        if (p === this.$el)
          return;
        p = p.parentNode;
      }

      this.showDropDown = false;
    }
  },
  mounted() {
    if (this.value)
      this.retrieveUserInfo()

    window.addEventListener('click', this.globalClickListener);
  },
  watch: {
    showDropDown() {
      if (this.showDropDown)
        this.$nextTick(() => this.$refs.searchTextInput.focus());
    },
    value() {
      const id = this.value && this.fullInfo ? this.value.user_id : this.value;
      if (this.value && (!this.selected || this.selected.user_id !== id))
        this.retrieveUserInfo();
    }
  }
}
</script>

<style scoped>
.dropdown-container {
  position: absolute;
  background: white;
  color: black;
  padding: 5px;
  left: 0;
  right: 0;
  top: 100%;
  box-shadow: 0 0 3px 0 #00000099;
  z-index: 99999;
  border-radius: 5px;
  max-height: 150px;
  overflow-y: auto;
}

.dp-item {
  padding: 5px;
  cursor: pointer;
}

.dp-item:hover {
  background: #555555ef;
  color: white;
}

</style>
